module.exports = __webpack_public_path__ + "static/media/ks.6014ceba.svg";